import {catchError, filter, map, mergeMap, bufferTime, tap} from 'rxjs/operators';
import {of, from} from 'rxjs';
import {networkError} from '../actions/ui';
import {combineEpics, ofType} from "redux-observable";
import {PROJECT, BID, SUBMITTAL, PUNCHLIST, DAILYLOG, TASK, RFI, MEETINGMINUTES} from "../services";
import * as R from 'ramda';
import {
  addFiles,
  API_UPLOAD_FILES_DONE, getBidSingleFile, getDailyLogSingleFile, getMeetingMinutesSingleFile,
  getProjectSingleFile, getPunchlistSingleFile, getRfiSingleFile,
  getSubmittalSingleFile, getTaskSingleFile
} from "../actions/files";
import {
  API_GET_FILES_DONE,
  API_UPLOAD_FILES,
  uploadFilesDone
} from "../actions/files";
import {postFile$} from "../services/files";
import {catchErrorsandResume, MODEL_INSERTION_BUFFER_INTERVAL_MS} from "./index";
import {APIError} from "../common/errors";



const processMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_FILES_DONE),
  filter(action => action.payload.response && action.payload.response.results),
  map(action => action.payload.response.results),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  map(results => R.unnest(results)),
  filter(results => results.length > 0),
  map(results => addFiles(results)),
  catchErrorsandResume(20022)
);

const uploadFileEpic = action$ => action$.pipe(
  ofType(API_UPLOAD_FILES),
  mergeMap(action =>
    from(action.payload.files.map(file => ({
          type: action.payload.type,
          id: action.payload.id,
          subId: action.payload.subId,
          metadata: file.metadata,
          file: file['file'],
    }))).pipe(
      mergeMap(fileData => postFile$(fileData).pipe(
        map(({response}) => uploadFilesDone(response, action)),
        catchError(error => of(networkError({...error, number: '10085-'+error.status})))
      )),
      catchError(error => of(networkError({...error, number: '10086-'+error.status})))
    )),
  catchErrorsandResume(20024)
);

function constructRefreshAction(response, prevAction) {
  const { id: fileId } = response;
  const { payload: { type, id: docId, subId }} = prevAction;
  switch (type) {
    case PROJECT:
      return getProjectSingleFile(docId, fileId);
    case BID:
      return getBidSingleFile(docId, fileId);
    case SUBMITTAL:
      return getSubmittalSingleFile(docId, subId, fileId);
    case PUNCHLIST:
      return getPunchlistSingleFile(docId, subId, fileId);
    case DAILYLOG:
      return getDailyLogSingleFile(docId, subId, fileId);
    case MEETINGMINUTES:
      return getMeetingMinutesSingleFile(docId, subId, fileId);
    case TASK:
      return getTaskSingleFile(docId, subId, fileId);
    case RFI:
      return getRfiSingleFile(docId, subId, fileId);
    default:
      throw new APIError("cannot construct refresh action; invalid document type");
  }
}

const refreshOnUploadEpic = action$ => action$.pipe(
  ofType(API_UPLOAD_FILES_DONE),
  map(action => constructRefreshAction(action.payload.response, action.payload.action)),
  catchErrorsandResume(20023)
);

export const filesEpic = combineEpics(
  processMultipleEpic,
  refreshOnUploadEpic,
  uploadFileEpic,
);



// WEBPACK FOOTER //
// ./src/network/files.js